/* eslint-disable react/no-array-index-key */
import { ColorSystemPositive1, Spacing4 } from 'autogen/design-tokens/tokens';
import type { CheckoutBasketDiscountInfoViewModel } from 'autogen/swagger/all';
import Icon from 'components/Icon';
import Layout from 'components/Layout';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import styled from 'styled-components';

const StyledFlexRow = styled(Layout.Flex.Row)`
    flex-wrap: wrap;
    gap: ${Spacing4};
`;

const StyledIcon = styled(Icon)`
    fill: ${ColorSystemPositive1};
`;

const StyledBody = styled(Typography.Body)`
    font-style: italic;
`;

export default function TriggeredDiscounts({
    model
}: {
    model: CheckoutBasketDiscountInfoViewModel['triggeredDiscounts'];
}) {
    return (
        <>
            {model.map((triggeredDiscount, index) => {
                if (triggeredDiscount.type === 'Discount') {
                    return (
                        <StyledFlexRow key={index}>
                            <WithIcon icon={<StyledIcon type="Checkmark" size={16} />}>
                                <Typography.Body as="span" size="S" strong>
                                    {triggeredDiscount.text}
                                </Typography.Body>
                            </WithIcon>
                        </StyledFlexRow>
                    );
                }

                if (triggeredDiscount.type === 'Disclaimer') {
                    return (
                        <StyledFlexRow key={index}>
                            {triggeredDiscount.showCheckmark ? (
                                <WithIcon icon={<StyledIcon type="Checkmark" size={16} />}>
                                    <StyledBody forwardedAs="span" size="S" strong>
                                        {triggeredDiscount.text}
                                    </StyledBody>
                                </WithIcon>
                            ) : (
                                <StyledBody forwardedAs="span" size="S" strong>
                                    {triggeredDiscount.text}
                                </StyledBody>
                            )}
                        </StyledFlexRow>
                    );
                }

                // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
                return null;
            })}
        </>
    );
}
